import { render, staticRenderFns } from "./AvailableSoon.vue?vue&type=template&id=8ff04936&"
import script from "./AvailableSoon.vue?vue&type=script&lang=js&"
export * from "./AvailableSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports